import http from "./Http";

const upload = async ({ file, dealer_id, make_slug }) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("dealer_id", dealer_id);
    formData.append("make_slug", make_slug);

    return http.post("/dealer-inventory-upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

const getLog = async (dealer_id) => {
    const params = new URLSearchParams({ dealerId: dealer_id });
    const response = await http.get(`/dealer-inventory-upload/log?${params.toString()}`);
    return response.data.data;
};

const DealerInventoryUploadService = {
    upload,
    getLog,
};

export default DealerInventoryUploadService;
